
<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
        <div class="h-30"></div>
              <div class="facility-heading">User Profile</div>
      <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">Manage Profile</span>
        </div>

        <app-user-profile></app-user-profile>
        <div class="h-30"></div>
        <div class="form-buttons">
            <button type="button" class="submit-form-button" (click)="navigate()">Edit Profile</button>
            <a routerLink="/change-password" class="submit-form-button cancel-button">Change password</a>
        </div>
    </div>
    </form>
</div>
</div>
</div>
